/**
 * When Xano only echoes realtime to the sending socket, other tabs (same user) never see
 * commentAdd. `storage` events fire in every other tab on the same origin — use that to
 * refetch the open thread's comments.
 */

export function commentThreadStorageKey(projectKey) {
  return `matchboxxr-thread-comments-${projectKey}`;
}

export function broadcastThreadCommentsNeedRefresh(projectKey, threadsId) {
  if (typeof window === "undefined" || projectKey == null || threadsId == null) return;
  try {
    window.localStorage.setItem(
      commentThreadStorageKey(projectKey),
      JSON.stringify({ threadsId: String(threadsId), t: Date.now() })
    );
  } catch (_) {
    /* quota / private mode */
  }
}

/** Returns unsubscribe. `onThread` receives threadsId string when another tab bumps the key. */
export function subscribeThreadCommentsCrossTab(projectKey, onThread) {
  if (typeof window === "undefined" || projectKey == null) {
    return () => {};
  }
  const key = commentThreadStorageKey(projectKey);
  const handler = (e) => {
    if (e.key !== key || e.newValue == null) return;
    let parsed;
    try {
      parsed = JSON.parse(e.newValue);
    } catch {
      return;
    }
    if (parsed?.threadsId != null) onThread(String(parsed.threadsId));
  };
  window.addEventListener("storage", handler);
  return () => window.removeEventListener("storage", handler);
}
